/**
 * Home Elektro Scroll Animations
 * IntersectionObserver-based fade-up-on-scroll animations
 */

(function() {
  'use strict';

  // Skip animations if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // Make all elements immediately visible
    document.querySelectorAll('.he-animate').forEach(function(el) {
      el.classList.add('he-animate--visible');
    });
    return;
  }

  // Initialize IntersectionObserver
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('.he-animate');

    if (animatedElements.length === 0) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry, index) {
        if (entry.isIntersecting) {
          const el = entry.target;

          // Add stagger delay based on data attribute or index
          const delay = el.dataset.animateDelay || (index * 100);
          if (delay > 0) {
            el.style.transitionDelay = (delay / 1000) + 's';
          }

          // Add visible class to trigger animation
          el.classList.add('he-animate--visible');

          // Stop observing once animated
          observer.unobserve(el);
        }
      });
    }, observerOptions);

    animatedElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  // Re-initialize on section load (Shopify editor)
  document.addEventListener('shopify:section:load', initScrollAnimations);

})();

/* ── Global card-title clamp (pixel-accurate, runs on every page) ── */
(function () {
  var TITLE_SEL = [
    '.he-card__title',
    '.he-new-card__title',
    '.he-fp-card__title',
    '.he-rp__card-title',
    '.pc-card__title'
  ].join(',');

  function clampTitles(root) {
    (root || document).querySelectorAll(TITLE_SEL).forEach(function (el) {
      var lh = parseFloat(getComputedStyle(el).lineHeight);
      if (!lh || isNaN(lh)) return;
      var cap = (Math.floor(lh * 2) - 1) + 'px';
      el.style.setProperty('max-height', cap, 'important');
      el.style.setProperty('min-height', cap, 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  window.clampTitles = clampTitles;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { clampTitles(); });
  } else {
    clampTitles();
  }

  document.addEventListener('shopify:section:load', function (e) {
    clampTitles(e.target);
  });
})();